import javaService from "../../utils/request"

 // 热门阅读
 export function HotRead(data){
  return javaService({
    url: '/front/popularReading',
    method: 'get',
    params: data,
  })
 }